export class BerryConfig {
  static isCollapse_menu = false;
  static font_family = 'Poppins'; // Roboto, poppins, inter
}
